import {Observable} from 'rxjs';

export interface Currency {
    id?: number;
    name: string;
    code: string;
    symbol?: string;
    active?: boolean;
}

export abstract class CurrenciesData {
    abstract list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any>;
    abstract get(id: number): Observable<Currency>;
    abstract update(currency: Currency): Observable<Currency>;
    abstract create(currency: Currency): Observable<Currency>;
    abstract delete(currency: Currency): Observable<Currency>;
}

